

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PurchaseAbstractParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface PurchaseAbstract {

  fromDate: any;
  ToDate: any;
 
  Supplier: string;
   
  skip:Number,
  take:Number,
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: PurchaseAbstractParameter[];
    links?: any;
}

export abstract class PurchaseAbstractData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<PurchaseAbstract[]>;
  abstract searchList(url: string,data: any): Observable<any>;
  abstract update(url: string,data: PurchaseAbstract): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
